module.exports = __webpack_public_path__ + "static/media/17349857_10154599675258990_5176470991163500631_o.da63997f.jpg";